import { FC, Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

// Static imports
import { PrivateRoute } from './PrivateRoute';
import { WbFallback } from 'components/wb-fallback';
import PreferenceManagement from '../../src/modules/Preference/PreferenceManagement';
import UnsubscribePage from '../../src/modules/Preference/Components/UnsubscribePage';
// Lazy imports
const SSO = lazy(() => import('modules/Login/Access/Components/SSO'));
const Content = lazy(() => import('modules/Content/Shared/ContentTab'));
const Login = lazy(() => import('modules/Login/Access/Components/Login'));
const SignUpPage = lazy(() => import('modules/Login/Access/Components/SignUpPage'));
const ResetPassword = lazy(() => import('modules/Login/Access/Components/ResetPassword'));
const LoginRedirect = lazy(() => import('modules/Login/Access/Components/LoginRedirect'));
const PermissionDenied = lazy(() => import('modules/Campaigns/Shared/PermissionDenied'));
const WelcomeAnimation = lazy(() => import('modules/Common/Components/WelcomeAnimation'));
const ContactsImport = lazy(() => import('modules/Login/Welcome/Components/ContactsImport'));
const CreateCampaign = lazy(() => import('modules/Campaigns/CampaignContent/Components/CreateCampaign'));
const EmailWithOutlookRedirect = lazy(() => import('modules/Publish/Components/EmailWithOutlookRedirect'));
const UnSubSorryPage = lazy(() => import('modules/Preference/Components/UnSubSorryPage'));
const WbDesignSystem = lazy(() => import('modules/wb-design-system'));

export const WbRoutes: FC = () => {
  const { NODE_ENV, REACT_APP_LINK } = process.env;
  const isDevelopment = NODE_ENV == 'development' || REACT_APP_LINK == 'https://qawb.xiqonline.com/';
  return (
    <Suspense fallback={<WbFallback />}>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/resetPassword/:resetKey?" component={ResetPassword} />
        <Route path="/login-redirect" component={LoginRedirect} />
        <Route exact path="/sso/:csrfToken/" component={SSO} />
        <Route path="/unsub-success" component={PreferenceManagement} exact />
        {/* i2c unsub and resub routes */}
        <Route path="/unsub/i2c/:unsubid" component={UnsubscribePage} exact />
        <Route path="/resub/i2c/:unsubid" component={UnSubSorryPage} exact />
        <Route path="/unsub/:unsubid" component={PreferenceManagement} exact />
        {/* the following route is only to be used for an issue in i2c email on Tuesday May 9, 2023 */}
        <Route path="/unsub/" component={UnsubscribePage} />
        {/* Following are the logged-in users routes */}
        <PrivateRoute path="/permission_denied" component={PermissionDenied} exact />
        <PrivateRoute path="/import" component={ContactsImport} exact />
        <PrivateRoute path="/welcome" component={WelcomeAnimation} exact />
        <PrivateRoute path="/content/:tab" component={Content} exact />
        <PrivateRoute path="/signup" component={SignUpPage} exact />
        <PrivateRoute path="/campaigns/:page?/:tab?/:subTab?" component={Content} exact />
        <PrivateRoute path="/createcampaign" component={CreateCampaign} exact />
        {/* <PrivateRoute path="/audiences/:page?/:tab?/:subTab?" component={Content} exact /> */}
        <PrivateRoute path="/audiences/:page?/:tab?/:subTab?" component={Content} exact />
        <PrivateRoute path="/analytics/:page?/:tab?" component={Content} exact />
        <PrivateRoute path="/buyer-journey/:tab?" component={Content} exact />
        <PrivateRoute path="/outlook_auth" component={EmailWithOutlookRedirect} exact />
        <PrivateRoute path="/automation/:page?/:tab?" component={Content} exact />
        <PrivateRoute path="/settings/:page?/:tab?" component={Content} exact />
        {isDevelopment && <Route path="/design-system" component={WbDesignSystem} />}
      </Switch>
    </Suspense>
  );
};
